import { render, staticRenderFns } from "./PlayCheckbox.vue?vue&type=template&id=45262ce1&scoped=true"
import script from "./PlayCheckbox.vue?vue&type=script&lang=js"
export * from "./PlayCheckbox.vue?vue&type=script&lang=js"
import style0 from "./PlayCheckbox.vue?vue&type=style&index=0&id=45262ce1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45262ce1",
  null
  
)

export default component.exports